import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mainView: 'posts',
  preferencesDialogOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setMainViewToPosts(state) {
      state.mainView = 'posts';
    },
    openPreferencesDialog(state) {
      state.preferencesDialogOpen = true;
    },
    closePreferencesDialog(state) {
      state.preferencesDialogOpen = false;
    },
  },
});

export const {
  setMainViewToPosts,
  openPreferencesDialog,
  closePreferencesDialog,
} = uiSlice.actions;

export const selectMainView = state => state.ui.mainView;
export const selectPreferencesDialogOpen = state =>
  state.ui.preferencesDialogOpen;

export default uiSlice.reducer;
